import { CampaignDetailsFields } from "Components/campaigns/CampaignDetails";
import apiConfig from "constants/apiConfig"
import { Campaign, CampaignDetail } from "types/campaign";
import { CTA, Milestone } from "types/campaign/collaborations";
import { CampaignInsightsData } from "types/campaign/insights";
import { PaymentsResponse } from "types/campaign/payments";
import { CampaignPerformanceData } from "types/campaign/performance";
import { CampaignRequirementResponse, RequirementDetails } from "types/campaign/requirement";
import { DiscoveryCreatorSort, RecommendedCreatorsResponse } from "types/creator-discovery";
import axiosClient from "utils/axiosClient"

export const fetchCampaigns = async (agencyId: string, payload: { page: number, status: string }) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGNS.url.replace('<agencyId>', agencyId), { params: { ...payload } });
    return response.data;
}

export const fetchCampaign = async (agencyId: string, campaignId: string): Promise<CampaignDetail> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data;
}

export const createCampaign = async (agencyId: string, payload: CampaignDetailsFields) => {
    const response = await axiosClient.post(apiConfig.CREATE_CAMPAIGN.url.replace('<agencyId>', agencyId), { ...payload});
    return response.data
}

export const fetchCampaignDetails = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_DETAILS.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data;
}

export const fetchCampaignCreateData = async (agencyId: string, ) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_CREATE_DATA.url.replace('<agencyId>', agencyId));

    return response.data;
}

export const fetchCampaignScreeningQuestions = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_SCREENING_QUESTIONS.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data;
}

export const createCampaignScreeningQuestion = async (agencyId: string, campaignId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.CREATE_CAMPAIGN_SCREENING_QUESTION.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), payload);

    return response.data;
}

export const updateCampaignScreeningQuestion = async (agencyId: string, campaignId: string, questionId: string, payload: any) => {
    const response = await axiosClient.put(apiConfig.UPDATE_CAMPAIGN_SCREENING_QUESTION.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        
        .replace('<questionId>', questionId), payload);

    return response.data;
}

export const deleteCampaignScreeningQuestion = async (agencyId: string, campaignId: string, questionId: string) => {
    const response = await axiosClient.delete(apiConfig.DELETE_CAMPAIGN_SCREENING_QUESTION.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<questionId>', questionId));

    return response.data;
}   

export const updateCampaignDetails = async (agencyId: string, campaignId: string, payload: CampaignDetailsFields) => {
    const response = await axiosClient.put(apiConfig.UPDATE_CAMPAIGN_DETAILS.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId), { ...payload});
    return response.data
}

export const fetchCampaignRequirement = async (agencyId: string, campaignId: string): Promise<CampaignRequirementResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_REQUIREMENT.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data;
}

export const fetchCities = async (agencyId: string, q: string = ''): Promise<string[]> => {
    const response = await axiosClient.get(apiConfig.FETCH_CITIES.url.replace('<agencyId>', agencyId), { params: { q } })
    return response.data.results as string[];
}

export const fetchTopics = async (q: string = ''): Promise<string[]> => {
    const response = await axiosClient.get(apiConfig.FETCH_TOPICS.url, { params: { q } })
    return response.data.results as string[];
}

export const updateCampaignRequirement = async (agencyId: string, campaignId: string, payload: RequirementDetails) => {
    const response = await axiosClient.post(apiConfig.FETCH_CAMPAIGN_REQUIREMENT.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), payload);

    return response.data;
}

export const fetchCampaignCreatives = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_CREATIVES.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data;
}

export const fetchCampaignGallery = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_GALLERY.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data;
}

export const addCampaignGalleryImage = async (agencyId: string, campaignId: string, payload: FormData) => {
    const response = await axiosClient.post(apiConfig.ADD_CAMPAIGN_GALLERY_IMAGE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });

    return response.data;
}

export const deleteCampaignGalleryImage = async (agencyId: string, campaignId: string, fileId: string) => {
    const response = await axiosClient.delete(apiConfig.DELETE_CAMPAIGN_GALLERY_IMAGE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<fileId>', fileId)
    );

    return response.data;
}

export const updateCampaignCreatives = async (agencyId: string, campaignId: string, payload: FormData) => {
    const response = await axiosClient.post(apiConfig.UPDATE_CAMPAIGN_CREATIVES.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), payload, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    });

    return response.data;
}

export const fetchCampaignPayments = async (agencyId: string, campaignId: string): Promise<PaymentsResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_PAYMENTS.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId))

    return response.data
}

export const fetchCampaignInsights = async (agencyId: string, campaignId: string): Promise<CampaignInsightsData> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_INSIGHTS.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId))

    return response.data
}

export const fetchCampaignPerformance = async (agencyId: string, campaignId: string, payload: any = {}): Promise<CampaignPerformanceData> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_PERFORMANCE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), { params: payload })

    return response.data
}

export const requestCampaignApproval = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.post(apiConfig.REQUEST_CAMPAIGN_APPROVAL.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId))

    return response.data
}

export const markCampaignComplete = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.post(apiConfig.MARK_CAMPAIGN_COMPLETED.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId))

    return response.data
}

export const fetchCampaignsCount = async (agencyId: string, brand_id?: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGNS_COUNT.url.replace('<agencyId>', agencyId), { params: { ...(brand_id !== 'all' ? { brand_id } : {}) } })

    return response.data.totals
}

export const fetchCampaignMilestones = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_MILESTONES.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data;
}

export const updateCampaignMilestones = async (agencyId: string, campaignId: string, milestones: Milestone[]) => {
    const response = await axiosClient.post(apiConfig.UPDATE_CAMPAIGN_MILESTONES.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), { milestones });

    return response.data;
}

export const updateCampaignMilestone = async (agencyId: string, campaignId: string, milestoneId: string, milestone: Milestone) => {
    const response = await axiosClient.put(apiConfig.UPDATE_CAMPAIGN_MILESTONE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId).replace('<milestoneId>', milestoneId), milestone);

    return response.data;
}

export const deleteCampaignMilestone =  async (agencyId: string, campaignId: string, milestoneId: string) => {
    const response = await axiosClient.delete(apiConfig.UPDATE_CAMPAIGN_MILESTONE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId).replace('<milestoneId>', milestoneId));

    return response.data;
}

export const createCampaignMilestone =  async (agencyId: string, campaignId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.CREATE_CAMPAIGN_MILESTONE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), payload);

    return response.data;
}

export const fetchCampaignGigs = async (agencyId: string, campaignId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_GIGS.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId));

    return response.data.gigs;
}

export const updateCampaignGig = async (agencyId: string, campaignId: string, gigId: number, payload: any) => {
    const response = await axiosClient.put(apiConfig.UPDATE_CAMPAIGN_GIG.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<gigId>', String(gigId)), payload);

    return response.data;
}

export const createCampaignGig = async (agencyId: string, campaignId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.CREATE_CAMPAIGN_GIG.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), payload);

    return response.data;
}


export const createAddress = async (agencyId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.CREATE_ADDRESS.url.replace('<agencyId>', agencyId), payload);
    return response.data;
}

export const updateMilestoneGigs = async (agencyId: string, campaignId: string, milestoneId: string | number, ids: number[]) => {
    const response = await axiosClient.post(apiConfig.UPDATE_MILESTONE_GIGS.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId)
        .replace('<milestoneId>', String(milestoneId)), { ids }
    );
    return response.data;
}

export const updateMilestoneCTAs = async (agencyId: string, campaignId: string,milestoneId: string | number, cta: CTA[]) => {
    const response = await axiosClient.post(apiConfig.UPDATE_MILESTONE_CTAS.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId)
        .replace('<milestoneId>', String(milestoneId)), { cta }
    );
    return response.data;
}

export const fetchCampaignActivity = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_ACTIVITY.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const searchCampaigns = async (q: string = '', agency_id: string, filters?: any): Promise<any[]> => {
    const response = await axiosClient.get(apiConfig.SEARCH_CAMPAIGNS.url.replace('<agencyId>', agency_id),{params: {q, ...(filters ? {...filters} : {})}});
    return response.data;
}

export const inviteCreatorsToCampaign = async (
    agencyId: string,
    campaignId: string,
    socialAccountIds: string[]
) => {
    const response = await axiosClient.post(
        apiConfig.INVITE_CREATORS_TO_CAMPAIGN.url
            .replace('<agencyId>', agencyId)
            .replace('<campaignId>', campaignId),
        { social_accounts: socialAccountIds }
    );
    return response.data;
}

export const copyCampaign = async (campaignId: string, agencyId: string) : Promise<Campaign | null> => {
    const response = await axiosClient.post(apiConfig.COPY_CAMPAIGN.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId));
    return response.data?.campaign ?? null;
}

export const attachIGPermalink = async (campaignId: string, agencyId: string, payload: {posts: any[]}) => {
    const response = await axiosClient.post(apiConfig.UPLOAD_IG_PERMALINK_TO_CAMPAIGN.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId), payload);
    return response.data;
}

export const fetchCampaignPermalinks = async (campaignId: string, agencyId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.UPLOAD_IG_PERMALINK_TO_CAMPAIGN.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId), {params: payload});
    return response.data;
}

export const createOfflineCampaign = async (agencyId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.CREATE_OFFLINE_CAMPAIGN.url.replace('<agencyId>', agencyId), payload);
    return response.data;
}

export const fetchCampaignContent = async (agencyId: string, campaignId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_CONTENT.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId), {params: payload});
    return response.data;
}

export const fetchCampaignStrategies = async (agencyId: string, brandSocialAccountId: string | number) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_STRATEGIES.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)));
    return response.data;
}

export const generateCampaignIdeas = async (agencyId: string, brandSocialAccountId: string | number, strategyUuid: string) => {
    const response = await axiosClient.post(apiConfig.GENERATE_CAMPAIGN_IDEAS.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)).replace('<strategyUuid>', strategyUuid));
    return response.data;
}

export const fetchCampaignIdeas = async (agencyId: string, brandSocialAccountId: string | number, strategyUuid: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_IDEAS.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)).replace('<strategyUuid>', strategyUuid));
    return response.data;
}

export const createCampaignFromIdea = async (agencyId: string, ideaUuid: string, platform: string) => {
    const response = await axiosClient.post(apiConfig.CREATE_CAMPAIGN_FROM_IDEA.url.replace('<agencyId>', agencyId).replace('<ideaUuid>', ideaUuid), { platform });
    return response.data;
}

export const generateCampaignIdeasFromBrief = async (agencyId: string, brandSocialAccountId: string | number, notes: string) => {
    const response = await axiosClient.post(apiConfig.GENERATE_CAMPAIGN_IDEAS_FROM_BRIEF.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)), { notes });
    return response.data;
}

export const fetchCampaignBrief = async (agencyId: string, brandSocialAccountId: string | number, briefId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_BRIEF.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)).replace('<briefId>', briefId));
    return response.data;
}

export const fetchCampaignBriefIdeas = async (agencyId: string, brandSocialAccountId: string | number, briefId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_BRIEF_IDEAS.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)).replace('<briefId>', briefId));
    return response.data;
}

export const fetchCampaignStrategy = async (agencyId: string, brandSocialAccountId: string | number, strategyUuid: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_STRATEGY.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)).replace('<strategyUuid>', strategyUuid));
    return response.data;
}

export const fetchRecentBriefs = async (agencyId: string, brandSocialAccountId: string | number) => {
    const response = await axiosClient.get(apiConfig.FETCH_RECENT_BRIEFS.url.replace('<agencyId>', agencyId).replace('<brandSocialAccountId>', String(brandSocialAccountId)));
    return response.data;
}

export const fetchRecommendedCreators = async (
    agencyId: string,
    campaignId: string,
    page = 1,
    sort: DiscoveryCreatorSort = 'rank',
    limit?: number
): Promise<RecommendedCreatorsResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_RECOMMENDED_CREATORS.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId), {
        params: {
            page,
            sort,
            ...(limit !== undefined ? { limit } : {}),
        },
    });
    return response.data;
};